/* eslint-disable prettier/prettier */
<template>
  <div>
    <b-container class="mt-3 pt-5 pb-5">
      <b-row>
        <b-col sm="12" class="px-4 px-sm-0">
          <b-img
            fluid
            src="https://res.cloudinary.com/oredev/image/upload/v1711637396/2024/connecting_hands.png"
          ></b-img>
        </b-col>
      </b-row>

      <b-row class="mt-3 text-center justify-content-center">
        <b-col cols="12" md="6" class="px-4 px-sm-0">
          <h1>Connect the Dots!</h1>
          <p>
            During Øredev 2024, we invite you to break free from silos and
            collectively shape the future of impactful and responsible
            technology with our theme: connect the dots! To truly understand and
            navigate the complexities of technology and its consequences, one
            must consider and connect all the diverse components and
            perspectives involved.
          </p>

          <p>
            'Connect the dots' encourages professionals from various tech
            domains to converge, share insights, and collectively envision the
            bigger picture; it gives an opportunity for us to be aware of the societal impact of
            our creations: it's about crafting solutions that not only function
            seamlessly but also contribute positively to the world around us.
          </p>

          <p>
            'Connect the Dots' is not just a theme but a mindset—a mindset that
            sparks creativity, encourages collaboration, and ensures that our
            technological advancements have a profound and positive impact on
            the world!
          </p>
        </b-col>
      </b-row>
    </b-container>
    <b-row no-gutters>
      <b-col cols="5" md="2">
        <b-img
          class="image-row mb-1 mb-sm-0 pr-1"
          src="https://res.cloudinary.com/oredev/image/upload/v1711638511/2024/53330597257_8c75207736_k_1.png"
        ></b-img
      ></b-col>
      <b-col cols="7" md="4">
        <b-img
          class="image-row mb-1 mb-0 pr-0 pr-md-1"
          src="https://res.cloudinary.com/oredev/image/upload/v1711638513/2024/53359575198_9607f5c399_k_1.png"
        ></b-img
      ></b-col>
      <b-col cols="12" md="6">
        <b-img
          class="image-row pb-1 pb-md-0"
          src="https://res.cloudinary.com/oredev/image/upload/v1711638514/2024/53331473126_656ea8ebdb_k_1.png"
        ></b-img
      ></b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

p {
  color: $text-dark;
}

.headline1 {
  font-size: 4rem;
  text-transform: uppercase;
  color: $orange;
}

.image-row {
  height: 600px; /* Set the maximum height of the image */
  width: inherit;
  object-fit: cover; /* This will crop and cover the area, you could also use 'contain' to fit the whole image without cropping */
  overflow: hidden;
}

@media (max-width: 767px) {
  /* Adjust the max-width according to your mobile breakpoint */
  .image-row {
    height: 300px; /* Height for mobile devices */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ThemeIntroduction.vue